<div
    class="container"
    [class.dark-make-connections]="themeService.isDark()"
>
    <div class="section-title text-start">
        <div class="row">
            <div class="col-lg-6 col-md-12">
                <span class="sub-title">MAKE CONNECTIONS</span>
                <h2>What We Offer For Growth</h2>
            </div>
            <div class="col-lg-6 col-md-12">
                <p>Nulla quis lorem ut libero malesuada feugiat. Pellentesque in ipsum id orci porta dapibus. Donec sollicitudin molestie malesuada.</p>
                <p class="bottom-zero">Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. Quisque velit nisi, pretium ut lacinia in, elementum id enim.</p>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-4 col-sm-6">
            <div class="overview-connections-card mb-30">
                <h3><span>01)</span> Exclusive Advisor</h3>
                <p>Nulla quis lorem ut libero malesuada feugiat pellentesque in ipsum id orci porta dapibus donec sollicitudin molestie malesuada quisque velit nisi pretium ut lacinia.</p>
            </div>
        </div>
        <div class="col-lg-4 col-sm-6">
            <div class="overview-connections-card mb-30">
                <h3><span>02)</span> Reached Your Goals</h3>
                <p>Nulla quis lorem ut libero malesuada feugiat pellentesque in ipsum id orci porta dapibus donec sollicitudin molestie malesuada quisque velit nisi pretium ut lacinia.</p>
            </div>
        </div>
        <div class="col-lg-4 col-sm-6">
            <div class="overview-connections-card mb-30">
                <h3><span>03)</span> Digital Laboratory</h3>
                <p>Nulla quis lorem ut libero malesuada feugiat pellentesque in ipsum id orci porta dapibus donec sollicitudin molestie malesuada quisque velit nisi pretium ut lacinia.</p>
            </div>
        </div>
    </div>
</div>